var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseupShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 401,
    height: 453,
    viewBox: "0 0 401 453",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_8765_17343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1699 5.64268C54.404 2.64457 57.3255 0.687744 60.5677 0.687744H392.234C396.652 0.687744 400.234 4.26947 400.234 8.68774V444.11C400.234 448.528 396.652 452.11 392.234 452.11H61.9462C58.0532 452.11 54.7254 449.307 54.0629 445.471L0.681196 136.388C0.424676 134.903 0.592962 133.376 1.16667 131.982L53.1699 5.64268Z",
    fill: "#441A98",
    fillOpacity: 0.22
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_8765_17343",
    x: -3.43555,
    y: -3.31226,
    width: 407.669,
    height: 459.422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8765_17343"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8765_17343",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseupShadow);
export default __webpack_public_path__ + "static/media/closeup_shadow.9143fd49dc722f87c1a110b2635022c9.svg";
export { ForwardRef as ReactComponent };